import { initFederation } from '@angular-architects/native-federation';
import './zone-fork-registry'; // Must run after zone.js (loaded as polyfill) and before any Angular bootstrap
import { environment } from './environments/environment';

// Reflect the build-time platform onto <html> BEFORE Angular paints, so CSS can gate
// native-feel styles via [data-platform="native"] with no flash of web layout.
// environment.platform is a compile-time constant (set by fileReplacements: web builds
// use environment(.prod).ts → 'web'; the native build config uses environment.native.ts →
// 'native'). This is the permanent home for the attribute (replaces the interim assignment
// that lived in bootstrap.ts during Phase 1).
document.documentElement.dataset.platform = environment.platform;

// Native only: prevent outer-viewport rubber-band scroll so only #content scrolls.
// On web (including phone-sized browsers) the browser manages its own scrolling — leave it be.
if (environment.platform === 'native') {
  document.addEventListener(
    'touchmove',
    (e) => {
      const path = e.composedPath() as HTMLElement[];
      const inContent = path.some((el) => el.id === 'content');
      if (!inContent) {
        e.preventDefault();
      }
    },
    { passive: false },
  );
}

// Native federation resolves ./remoteEntry.json and import map entries relative to <base href>.
// It requires a trailing slash (e.g. /app-isso/) but the original base-path has no trailing slash.
// Add it here before initFederation runs. Angular's APP_BASE_HREF is set separately in bootstrap
// via computeBaseHref which strips the trailing slash for correct router path matching.
const baseEl = document.querySelector('base');
const originalBase = baseEl?.getAttribute('href') || '/';
if (baseEl && !originalBase.endsWith('/')) {
  baseEl.setAttribute('href', originalBase + '/');
}
const options = environment.production ? { cacheTag: 'remoteEntry.20260910T205415.json' } : {};
console.log({ options });
initFederation({}, options)
  .catch((err) => console.error(err))
  .then((_) => import('./bootstrap').then((m) => m.initAppShell()))
  .catch((err) => console.error(err));
